import { render } from "./CIS-List-Link-Extra-Links.vue?vue&type=template&id=0a7ab6bc&scoped=true"
import script from "./CIS-List-Link-Extra-Links.vue?vue&type=script&lang=js"
export * from "./CIS-List-Link-Extra-Links.vue?vue&type=script&lang=js"

import "./CIS-List-Link-Extra-Links.vue?vue&type=style&index=0&id=0a7ab6bc&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0a7ab6bc"]])

export default __exports__